export const UPDATED_CHECKOUT_APPOINTMENT_STEP_DATA =
  "UPDATED_CHECKOUT_APPOINTMENT_STEP_DATA";
export const GET_POS_SETTINGS = "GET_POS_SETTINGS";
export const GOT_POS_SETTINGS = "GOT_POS_SETTINGS";
export const GET_GIFTCERT_SETTING = "GET_GIFTCERT_SETTING";
export const GOT_GIFTCERT_SETTING = "GOT_GIFTCERT_SETTING";
export const GET_INVOICE = "GET_INVOICE";
export const GOT_INVOICE = "GOT_INVOICE";

export const CREATE_INVOICE = "CREATE_INVOICE";
export const CREATED_INVOICE = "CREATED_INVOICE";

export const UPDATE_INVOICE = "UPDATE_INVOICE";
export const UPDATED_INVOICE = "UPDATED_INVOICE";

export const UPDATE_BOOKING_TO_INVOICE = "UPDATE_BOOKING_TO_INVOICE";
export const UPDATED_BOOKING_TO_INVOICE = "UPDATED_BOOKING_TO_INVOICE";

export const GET_BOOKING_PAYMENTS = "GET_BOOKING_PAYMENTS";
export const GOT_BOOKING_PAYMENTS = "GOT_BOOKING_PAYMENTS";

export const REFUND_INVOICE_PAYMENT = "REFUND_INVOICE_PAYMENT";
export const REFUNDED_INVOICE_PAYMENT = "REFUNDED_INVOICE_PAYMENT";

export const CHARGE_EXISTING_CARD = "CHARGE_EXISTING_CARD";
export const CHARGED_EXISTING_CARD = "CHARGED_EXISTING_CARD";

export const SEND_SHARE_INVOICE = "SEND_SHARE_INVOICE";
export const SENT_SHARE_INVOICE = "SENT_SHARE_INVOICE";

export const GET_INVOICE_PDF = "GET_INVOICE_PDF";
export const GOT_INVOICE_PDF = "GOT_INVOICE_PDF";

export const FIND_GIFT_CERTIFICATE = "FIND_GIFT_CERTIFICATE";
export const FOUND_GIFT_CERTIFICATE = "FOUND_GIFT_CERTIFICATE";
export const REMOVE_GIFT_CERTIFICATE = "REMOVE_GIFT_CERTIFICATE";
export const REDEEM_GIFT_CERTIFICATE = "REDEEM_GIFT_CERTIFICATE";
export const REDEEMED_GIFT_CERTIFICATE = "REDEEMED_GIFT_CERTIFICATE";

export const CREATE_GIFT_CERTIFICATE = "CREATE_GIFT_CERTIFICATE";
export const CREATED_GIFT_CERTIFICATE = "CREATED_GIFT_CERTIFICATE";
export const GET_GIFT_CERTIFICATE = "GET_GIFT_CERTIFICATE";
export const GOT_GIFT_CERTIFICATE = "GOT_GIFT_CERTIFICATE";

export const UPDATED_DISCOUNT_MENU_VISIBILITY =
  "UPDATED_DISCOUNT_MENU_VISIBILITY";

export const UPDATED_CHECKOUT_MODE = "UPDATED_CHECKOUT_MODE";

export const UPDATED_PAYMENT_MODE = "UPDATED_PAYMENT_MODE";

export const UPDATED_TIP_POPUP_VISIBILITY = "UPDATED_TIP_POPUP_VISIBILITY";

export const UPDATED_SHARE_INVOICE_VISIBILITY =
  "UPDATED_SHARE_INVOICE_VISIBILITY";

export const CHANGE_UPDATE_INVOICE_TO_BOOKING = "UPDATE_INVOICE_TO_BOOKING";

export const UPDATE_GETTING_STRIPE_TOKEN = "UPDATE_GETTING_STRIPE_TOKEN";

export const UPDATE_INVOICE_AFTER_PAYMENT = "UPDATE_INVOICE_AFTER_PAYMENT";

export const UPDATE_GIFT_CERT_SALE_FORM_VISIBILITY =
  "UPDATE_GIFT_CERT_SALE_FORM_VISIBILITY";

export const ADD_KEY_TO_GIFT_CERT_VALUE_LIST =
  "ADD_KEY_TO_GIFT_CERT_VALUE_LIST";

export const GET_PAYMENT_SETTING = "GET_PAYMENT_SETTING";

export const PAYMENT_SETTING_SUCCESS = "PAYMENT_SETTING_SUCCESS";

export function getPaymentSetting(data) {
  return {
    type: GET_PAYMENT_SETTING,
    data
  };
}

export function paymentSettingSuccess(data) {
  return {
    type: PAYMENT_SETTING_SUCCESS,
    data
  };
}
export function updateCheckoutAppointmentStepData(stepData) {
  return {
    type: UPDATED_CHECKOUT_APPOINTMENT_STEP_DATA,
    data: stepData
  };
}

export function getPosSettings(stepData) {
  return {
    type: GET_POS_SETTINGS
  };
}

export function getGiftCertSetting() {
  return {
    type: GET_GIFTCERT_SETTING
  };
}

export function getInvoice(key) {
  return {
    type: GET_INVOICE,
    invoiceKey: key
  };
}

export function createInvoice(payload, cb) {
  return {
    type: CREATE_INVOICE,
    payload: payload,
    cb: cb
  };
}

export function updateInvoice(key, payload, cb) {
  return {
    type: UPDATE_INVOICE,
    invoiceKey: key,
    payload: payload,
    cb: cb
  };
}

export function updateBookingToInvoice(bookingId, payload, cb) {
  return {
    type: UPDATE_BOOKING_TO_INVOICE,
    bookingId: bookingId,
    payload: payload,
    cb: cb
  };
}

export function refundInvoicePayment(bookingId, paymentId) {
  return {
    type: REFUND_INVOICE_PAYMENT,
    bookingId: bookingId,
    paymentId: paymentId
  };
}

export function chargeExistingCard(bookingId, payload, cb) {
  return {
    type: CHARGE_EXISTING_CARD,
    bookingId: bookingId,
    payload: payload,
    cb: cb
  };
}

export function getBookingPayments(bookingId, cb) {
  return {
    type: GET_BOOKING_PAYMENTS,
    bookingId: bookingId,
    cb: cb
  };
}

export function sendShareInvoice(invoiceKey, payload) {
  return {
    type: SEND_SHARE_INVOICE,
    invoiceKey: invoiceKey,
    payload: payload
  };
}

export function getInvoicePdf(invoiceKey) {
  return {
    type: GET_INVOICE_PDF,
    invoiceKey: invoiceKey
  };
}

export function findGiftCertificate(giftCertCode) {
  return {
    type: FIND_GIFT_CERTIFICATE,
    payload: { query: giftCertCode }
  };
}

export function removeGiftCertificate() {
  return {
    type: REMOVE_GIFT_CERTIFICATE
  };
}

export function redeemGiftCertificate(giftCertKey, payload) {
  return {
    type: REDEEM_GIFT_CERTIFICATE,
    giftCertKey: giftCertKey,
    payload: payload
  };
}

export function createGiftCertificate(payload, cb) {
  return {
    type: CREATE_GIFT_CERTIFICATE,
    payload: payload,
    cb: cb
  };
}

export function updateDiscountDropdownVisibility(isVisible) {
  return {
    type: UPDATED_DISCOUNT_MENU_VISIBILITY,
    data: isVisible
  };
}

export function updateCheckoutMode(checkoutMode) {
  return {
    type: UPDATED_CHECKOUT_MODE,
    data: checkoutMode
  };
}

export function updatePaymentMode(paymentMode) {
  return {
    type: UPDATED_PAYMENT_MODE,
    data: paymentMode
  };
}

export function changeTipPopupVisibility(tipPopupVisible) {
  return {
    type: UPDATED_TIP_POPUP_VISIBILITY,
    data: tipPopupVisible
  };
}

export function updateShareInvoiceVisibility(shareInvoiceVisible) {
  return {
    type: UPDATED_SHARE_INVOICE_VISIBILITY,
    shareInvoiceVisible: shareInvoiceVisible
  };
}

export function changeUpdateInvoiceToBooking(shouldUpdateInvoiceToBooking) {
  return {
    type: CHANGE_UPDATE_INVOICE_TO_BOOKING,
    data: shouldUpdateInvoiceToBooking
  };
}

export function updateGettingStripeToken(isGettingStripeToken) {
  return {
    type: UPDATE_GETTING_STRIPE_TOKEN,
    isGettingStripeToken: isGettingStripeToken
  };
}

export function updateInvoiceAfterPayment(data) {
  return {
    type: UPDATE_INVOICE_AFTER_PAYMENT,
    data: data
  };
}

export function updateGiftCertSaleFormVisibility(visible) {
  return {
    type: UPDATE_GIFT_CERT_SALE_FORM_VISIBILITY,
    data: visible
  };
}

export function addNewGiftCertKeyToValueList(giftCertKey) {
  return {
    type: ADD_KEY_TO_GIFT_CERT_VALUE_LIST,
    data: giftCertKey
  };
}

export function getGiftCertWithKey(giftCertKey) {
  return {
    type: GET_GIFT_CERTIFICATE,
    giftCertKey: giftCertKey
  };
}
